import React from 'react'
import { DEPARTMENTS } from './constants'

export function renderWorkers(ctx) {
  const {
    activeTab,
    activeWorkers,
    editForm,
    editWorker,
    filteredWorkers,
    handleAddWorker,
    handleDeleteWorker,
    handleSaveWorker,
    openEditWorker,
    setEditForm,
    setEditWorker,
    setWorkerForm,
    setWorkerSearch,
    t,
    toggleChatAccess,
    toggleWorkerStatus,
    workerForm,
    workerSearch,
    workerStatus,
    workers,
  } = ctx
  return (
    <>
          {activeTab === 'workers' && (
            <div className="dash-section">
              <div className="dash-section-header"><h2>{t.workerManagement}</h2><p>{t.addAndManageTeam}</p></div>
              <div className="dash-two-col">
                <div className="dash-form-card">
                  <h3>{t.addNewWorker}</h3>
                  <form className="dash-form" onSubmit={handleAddWorker}>
                    <div className="dash-form-row">
                      <label>{t.fullName} <span className="dash-required">*</span><input type="text" value={workerForm.name} onChange={e => setWorkerForm(p => ({ ...p, name: e.target.value }))} placeholder="Jean Dupont" /></label>
                      <label>{t.rolePosition} <span className="dash-required">*</span><input type="text" value={workerForm.role} onChange={e => setWorkerForm(p => ({ ...p, role: e.target.value }))} placeholder="Project Manager" /></label>
                    </div>
                    <div className="dash-form-row">
                      <label>{t.department}
                        <select value={workerForm.department} onChange={e => setWorkerForm(p => ({ ...p, department: e.target.value }))}>
                          {DEPARTMENTS.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                        </select>
                      </label>
                      <label>{t.region}<input type="text" value={workerForm.region} onChange={e => setWorkerForm(p => ({ ...p, region: e.target.value }))} placeholder="Central African Republic" /></label>
                    </div>
                    <div className="dash-form-row">
                      <label>{t.email}<input type="email" value={workerForm.email} onChange={e => setWorkerForm(p => ({ ...p, email: e.target.value }))} placeholder="jean@groupeouambo.com" /></label>
                      <label>{t.phone}<input type="tel" value={workerForm.phone} onChange={e => setWorkerForm(p => ({ ...p, phone: e.target.value }))} placeholder="+237 6xx xxx xxx" /></label>
                    </div>
                    <div className="dash-form-row">
                      <label>{t.dashboardPassword} <span className="dash-required">*</span><input type="password" value={workerForm.password} onChange={e => setWorkerForm(p => ({ ...p, password: e.target.value }))} placeholder={t.workerLoginPassword} /></label>
                    </div>
                    <div className="dash-form-actions">
                      <button className="dash-btn primary" type="submit">{t.addWorker}</button>
                      {workerStatus && <span className="dash-status-msg">{workerStatus}</span>}
                    </div>
                  </form>
                </div>
                <div className="dash-info-card">
                  <h3>{t.departmentSummary}</h3>
                  {DEPARTMENTS.map(dept => {
                    const count = workers.filter(w => w.department === dept.value).length
                    return (
                      <div key={dept.value} className="dash-dept-row">
                        <span className={`dash-dept-dot ${dept.value}`}></span>
                        <span className="dash-dept-name">{dept.label}</span>
                        <span className="dash-dept-count">{count}</span>
                      </div>
                    )
                  })}
                  <div className="dash-dept-total"><strong>Total: {workers.length}</strong><span>{activeWorkers} active</span></div>
                </div>
              </div>

              <div className="dash-table-card">
                <div className="dash-table-header">
                  <h3>{t.allWorkers} ({workers.length})</h3>
                  <input className="dash-search" type="search" placeholder={t.search} value={workerSearch} onChange={e => setWorkerSearch(e.target.value)} />
                </div>
                {filteredWorkers.length === 0 ? (
                  <div className="dash-empty-state"><span>👥</span><p>{workers.length === 0 ? t.noWorkers : t.noResults}</p></div>
                ) : (
                  <div className="dash-table-wrap">
                    <table className="dash-table">
                      <thead><tr><th>{t.name}</th><th>{t.role}</th><th>{t.department}</th><th>{t.region}</th><th>{t.contact}</th><th>{t.status}</th><th>Chat Access</th><th>{t.actions}</th></tr></thead>
                      <tbody>
                        {filteredWorkers.map(w => (
                          <tr key={w.id}>
                            <td><div className="dash-table-avatar-cell">{w.avatar ? <img src={w.avatar} alt={w.name} className="dash-table-avatar-img" /> : <span className="dash-table-avatar">{w.name[0]?.toUpperCase()}</span>}<span>{w.name}</span></div></td>
                            <td>{w.role}</td>
                            <td><span className={`dash-cat-badge ${w.department}`}>{DEPARTMENTS.find(d => d.value === w.department)?.label || w.department}</span></td>
                            <td>{w.region || '—'}</td>
                            <td className="dash-table-contact">{w.email && <a href={`mailto:${w.email}`}>{w.email}</a>}{w.phone && <span>{w.phone}</span>}</td>
                            <td><button className={`dash-status-toggle ${w.status}`} onClick={() => toggleWorkerStatus(w.id)}>{w.status}</button></td>
                            <td>
                              <button
                                onClick={() => toggleChatAccess(w.id)}
                                style={{ padding: '4px 10px', borderRadius: 6, border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: '0.78rem', background: w.chat_access ? '#16a34a' : '#e5e7eb', color: w.chat_access ? '#fff' : '#6b7280' }}
                              >
                                {w.chat_access ? '💬 Enabled' : 'Off'}
                              </button>
                            </td>
                            <td className="dash-table-actions">
                              <button className="dash-edit-btn" onClick={() => openEditWorker(w)}>{t.edit}</button>
                              <button className="dash-delete-btn" onClick={() => handleDeleteWorker(w.id)}>{t.remove}</button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          )}

          {editWorker && (
            <div className="dash-modal-overlay" onClick={() => setEditWorker(null)}>
              <div className="dash-modal" onClick={e => e.stopPropagation()}>
                <div className="dash-modal-header">
                  <h3>{t.editWorker}</h3>
                  <button className="dash-modal-close" onClick={() => setEditWorker(null)}>✕</button>
                </div>
                <form className="dash-form" onSubmit={handleSaveWorker}>
                  <div className="dash-form-grid">
                    <label>{t.fullName} <span className="dash-required">*</span>
                      <input type="text" value={editForm.name || ''} onChange={e => setEditForm(p => ({ ...p, name: e.target.value }))} required />
                    </label>
                    <label>{t.rolePosition} <span className="dash-required">*</span>
                      <input type="text" value={editForm.role || ''} onChange={e => setEditForm(p => ({ ...p, role: e.target.value }))} required />
                    </label>
                    <label>{t.department}
                      <select value={editForm.department || 'logistics'} onChange={e => setEditForm(p => ({ ...p, department: e.target.value }))}>
                        {DEPARTMENTS.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                      </select>
                    </label>
                    <label>{t.region}
                      <input type="text" value={editForm.region || ''} onChange={e => setEditForm(p => ({ ...p, region: e.target.value }))} />
                    </label>
                    <label>{t.email}
                      <input type="email" value={editForm.email || ''} onChange={e => setEditForm(p => ({ ...p, email: e.target.value }))} />
                    </label>
                    <label>{t.phone}
                      <input type="tel" value={editForm.phone || ''} onChange={e => setEditForm(p => ({ ...p, phone: e.target.value }))} />
                    </label>
                    <label>{t.dashboardPassword}
                      <input type="password" value={editForm.password || ''} onChange={e => setEditForm(p => ({ ...p, password: e.target.value }))} placeholder="Leave unchanged or set new" />
                    </label>
                  </div>
                  <div className="dash-form-actions">
                    <button type="button" className="dash-btn secondary" onClick={() => setEditWorker(null)}>{t.cancel}</button>
                    <button type="submit" className="dash-btn primary">{t.saveChanges}</button>
                  </div>
                </form>
              </div>
            </div>
          )}
    </>
  )
}
